import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col } from 'antd'
import { ExclamationOutlined } from '@ant-design/icons'
import '../../css/patient.scss'
import { constants } from '../../constants'
import _ from 'lodash'
import moment from 'moment'

const PatientEvents = (props) => {
  var getMonthlyEvents = (events) => {
    var date = props.date ? props.date : new Date()
    var data = []
    events.forEach((e, i) => {
      var d = new Date(e.date)
      if (
        d.getMonth() + ' ' + d.getFullYear() ==
        date.getMonth() + ' ' + date.getFullYear()
      )
        data.push(e)
    })
    return data
  }

  var renderEvents = () => {
    var events = props.patient?.eventSchedule
      ? getMonthlyEvents(props.patient?.eventSchedule)
      : []
    return events.length > 0 ? (
      events.map((event) => (
        <Row className='eventRow'>
          <Col>
            <Row className='eventHeader'>
              {moment(event.date).format('MMMM DD')} -{event.title}
            </Row>
            <Row className='eventMessage' hidden={!event.message}>
              {event.message}
            </Row>
          </Col>
        </Row>
      ))
    ) : (
      <Row justify='center' align='middle' style={{ height: 150 }}>
        <Col>
          <h3>No Reminders</h3>
        </Col>
      </Row>
    )
  }
  return (
    <Col className='patientEventsContainer'>
      <Row className='eventRow sticky'>
        <Col className='eventHeader'>
          <ExclamationOutlined className='eventIcon' />
        </Col>
        <Col className='eventHeader'>REMINDERS</Col>
      </Row>
      {renderEvents()}
    </Col>
  )
}

PatientEvents.propTypes = {
  patient: PropTypes.object,
  date: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    patient: state.patient.patient,
  }
}

export default connect(mapStateToProps, null)(PatientEvents)
